import { churchesApi } from '../api/churchesApi'

export const getChurches = async () => {
  try {
    const {
      data: { churches },
    } = await churchesApi.getChurches()
    return churches
  } catch (error) {
    console.error(`Error fetching churches: `, error)
    throw error
  }
}
